import { RouteObject, redirect } from 'react-router-dom';
import { routeAccount } from './app/components/account/account.route';
import { routeEditCommPreferences } from './app/components/account/components/edit-comm-preferences/edit-comm-preferences.route';
import { routeEditMembership } from './app/components/account/components/edit-membership/edit-membership.route';
import { routeEditPersonalInfo } from './app/components/account/components/edit-personal-info/edit-personal-info.route';
import { routeActionPlan } from './app/components/action-plan/action-plan.route';
import { routeBuildActionPlan } from './app/components/action-plan/components/build-action-plan/build-action-plan.route';
import { routeDashboard } from './app/components/dashboard/dashboard.route';
import { routeEarlyAccess } from './app/components/early-access/early-access.route';
import { routeLoadingScreen } from './app/components/loading-screen/loading-screen.route';
import { routePayment } from './app/components/payment/payment.route';
import {
  routePpra,
  routePpraMembershipInterstitial,
  routePpraPayment,
  routePpraQuestionnaire,
  routePpraResults,
  routePpraResultsLoading,
  routePpraResultsPdp,
} from './app/components/ppra/ppra.route';
import { routeQuestionnaire } from './app/components/questionnaire/questionnaire.route';
import { routeRiskAnalysis } from './app/components/risks/risk-analysis/risk-analysis.route';
import { routeRiskTrend } from './app/components/risks/risk-trend/risk-trend.route';
import { routeSingleCancerView } from './app/components/risks/single-cancer-view/single-cancer-view.route';
import { routeSignIn } from './app/components/sign-in/sign-in.route';
import { routeSignUp } from './app/components/sign-up/sign-up.route';
import { routeTestDetails } from './app/components/testing-plan/components/test-details/test-details.route';
import { routeTestingPlanComplete } from './app/components/testing-plan/components/your-testing-plan/components/complete-test/complete-test.route';
import { routeTestingPlan } from './app/components/testing-plan/testing-plan.route';
import { routeWearables } from './app/components/wearables/wearables.route';
import { routeLabs } from './app/components/labs/labs.route';
import { routeLabsAll } from './app/components/labs/labs-all.route';
import { routeBiomarkerDetail } from './app/components/labs/components/biomarker-detail/biomarker-detail.route';
import { routeLabsOrder } from './app/components/labs-order/labs-order.route';
import { routeConsent } from './app/components/consent/consent.route';
import { routeHealthData } from './app/components/health-data/health-data.route';
import Layout from './components/layout-auth/layout-auth'; // actually not used for authenticated routes, so that's cool
import MainLayout from './components/main-layout/main-layout'; // this is what is used for authenticated routes
import { ROUTE_SIGN_IN } from './constants/routes';
import authService from './services/auth.service';
import { routeQuizlet, routeQuizletQuestionnaire, routeQuizletResults } from './app/components/quizlet/quizlet.route';
import { routeQuizletVariant } from './app/components/quizlet/quizlet-variant.route';
import { routeQuestionnaireV2 } from './app/components/questionnaireV2/components/questionnaireV2.route';
import { routeRiskScoreReveal } from './app/components/risk-score-reveal/risk-score-reveal.route';
import { generateAllQuizletRoutes } from './app/components/quizletv2/quizlet-generic.route';
import { getEnabledQuizletVersions } from './app/components/quizletv2/quizlet-config';

const router: Array<RouteObject> = [
  {
    loader() {
      if (!authService.isLoggedIn()) {
        // This doesn't check for "isLoggedIn", it only checks for the access token in local storage
        // It doesn't matter if it's valid or not, so that's also cool
        return redirect(ROUTE_SIGN_IN);
      }
      return null;
    },
    children: [
      {
        Component: MainLayout,
        children: [
          routeAccount,
          routeEditPersonalInfo,
          routeActionPlan,
          routeQuestionnaire,
          routeTestingPlan,
          routeTestDetails,
          routeTestingPlanComplete,
          routeDashboard,
          routeBuildActionPlan,
          routeEditMembership,
          routeRiskAnalysis,
          routeRiskTrend,
          routeSingleCancerView,
          routeEditCommPreferences,
          routeLoadingScreen,
          routeQuestionnaireV2,
          routeRiskScoreReveal,
          routeWearables,
          routeLabs,
          routeLabsAll,
          routeBiomarkerDetail,
          routeLabsOrder,
          routeConsent,
          routeHealthData,
        ],
      },
    ],
  },
  {
    Component: Layout,
    children: [
      routeSignUp,
      routeEarlyAccess,
      routeSignIn,
      routePayment,
      routePpra,
      routePpraPayment,
      routePpraQuestionnaire,
      routePpraResults,
      routePpraResultsLoading,
      routePpraResultsPdp,
      routePpraMembershipInterstitial,
      routeQuizletVariant,  // Variant-aware route for /quizlet
      routeQuizlet,
      routeQuizletQuestionnaire,
      routeQuizletResults,
      // Generate all configured quizlet version routes dynamically (v2, v4, etc.)
      ...generateAllQuizletRoutes(getEnabledQuizletVersions()),
    ],
  },
];

export default router;
